import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import Unidade from "./Unidade";
import Lista from "./Lista";
import PlanoAulas from "./PlanoAulas";

const Index = ({ match }) => (
  <div className="content-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} />
      <Route path={`${match.url}/lista`} component={Lista} />
      <Route path={`${match.url}/item/:id`} component={Unidade} />
      <Route
        exact
        path={`${match.url}/plano-aulas/:id`}
        component={PlanoAulas}
      />
    </Switch>
  </div>
);

export default Index;
